import { render, staticRenderFns } from "./IsraelContactPersonsListItem.vue?vue&type=template&id=ab8e1e1e&scoped=true&"
import script from "./IsraelContactPersonsListItem.vue?vue&type=script&lang=js&"
export * from "./IsraelContactPersonsListItem.vue?vue&type=script&lang=js&"
import style0 from "./IsraelContactPersonsListItem.vue?vue&type=style&index=0&id=ab8e1e1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab8e1e1e",
  null
  
)

export default component.exports